import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
export function useCheckAuthScope(scopes) {
    var _a;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var user = useAuth().user;
    var isAuthed = useState((_a = user === null || user === void 0 ? void 0 : user.groups) === null || _a === void 0 ? void 0 : _a.some(function (group) { return scopes.find(function (scope) { return group.indexOf(scope) >= 0; }); }))[0];
    return isAuthed;
}
